import { render } from "./HeadingParagraphTextContainer.vue?vue&type=template&id=39c3ae86"
import script from "./HeadingParagraphTextContainer.vue?vue&type=script&lang=js"
export * from "./HeadingParagraphTextContainer.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__